<template>
    <div>
      <v-card width="100%" v-if="current">
        <v-card-title>Status das OLTs</v-card-title>
        <v-card-text>
          <div><strong>OLT: </strong>{{ olt.name }}</div>
          <v-simple-table>
            <thead>
                <tr>
                    <th>Interface</th>
                    <th>Total</th>
                    <th>UP</th>
                    <th>DOWN</th>
                    <th>Exportar</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in current" :key="index" :style="bgItem(item)">
                    <td>{{ item.fsp }}</td>
                    <td>{{ item.total }}</td>
                    <td>{{ item.up }}</td>
                    <td>{{ item.down }}</td>
                    <td>
                        <v-icon color="primary" title="Exportar seriais das ONTs" @click="exportONTs(item)">mdi-download</v-icon>
                    </td>
                </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
      </v-card>

      <v-dialog v-model="dialog_loading" persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Por favor aguarde
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
</template>

<script>
import api from "../../api/index.js";
export default {
    data: () => ({
        current: null,
        olt: null,
        sports: [],
        counter_service_port: 0,
        dialog_loading: false
    }),
    created: function() {
        this.load();
        this.loadOlt();
    },
    methods: {
        load: function(){
            var me = this;
            var token = localStorage.getItem("token");
            api
                .get("/olt_service_port/status/" + this.$route.params.id, { headers: { Authorization: "Bearer " + token } })
                .then(function(response) {
                    me.sports = response.data;
                    me.counter_service_port = me.sports.length;
                    me.processSP();
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        loadOlt: function(){
            var me = this;
            var token = localStorage.getItem("token");
            api
                .get("/olt/" + this.$route.params.id, { headers: { Authorization: "Bearer " + token } })
                .then(function(response) {
                    me.olt = response.data;
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        processSP: function(){
            let cache = {};
            for(var i=0;i<this.counter_service_port;i++){
                const sp = this.sports[i];
                let olt = sp.oltId;
                let ofsp = olt + sp.fsp;
                let fsp = cache[ofsp];
                let up = 0;
                let down = 0;
                let total = 0;
                if(fsp){
                    up = fsp.up;
                    down = fsp.down;
                    total = fsp.total;
                }
                if(sp.status=='up'){
                    up++;
                    total++;
                }else if(sp.status=='down'){
                    down++;
                    total++;
                }
                cache[ofsp] = {
                    olt: olt,
                    fsp: sp.fsp,
                    up: up,
                    down: down,
                    total: total
                };
            }
            console.log(cache);
            this.current = cache;
        },
        exportONTs: function(item){
            var me = this;
            var token = localStorage.getItem("token");
            this.dialog_loading = true;
            api
                .get("/ont/olt/" + item.olt + "?fsp=" + item.fsp, { headers: { Authorization: "Bearer " + token } })
                .then(function(response) {
                    var onts = response.data;
                    var serials = (onts || [])
                        .map(function(ont){ return ont.serial; })
                        .filter(function(serial){ return serial; });
                    if(serials.length == 0){
                        alert("Nenhuma ONT encontrada na interface " + item.fsp);
                        return;
                    }
                    me.download(serials.join("\n") + "\n", "huawei-" + item.olt + "-" + item.fsp.replace(/\//g, "_") + ".txt");
                })
                .catch(function(error) {
                    console.log(error);
                    alert("Erro ao exportar as ONTs da interface " + item.fsp);
                })
                .finally(() => {
                    me.dialog_loading = false;
                });
        },
        download: function(content, filename){
            var blob = new Blob([content], { type: "text/plain;charset=utf-8" });
            var url = window.URL.createObjectURL(blob);
            var link = document.createElement("a");
            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        },
        bgItem: function(item){
            let dp = item.down / item.total;
            if(dp > 0.4){
                 return {
                     backgroundColor: '#ff6961'
                 };
             } else if(dp > 0.2){
                 return {
                     backgroundColor: '#fdfd96'
                 };
             }
        }
    }
}
</script>
